/** @format */
import { Box, Button, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useStyles } from './Style';
import { SimpleDialog, Icons } from 'components';
import { BodyForm } from './components';
import Params from './components/Params';



const BodyParameters = ({ bodyChange, dataBody }) => {
  const classes = useStyles();

  const [openDialog, setOpenDialog] = useState(false);
  const [titleDialog] = useState('تعریف پارامتر جدید');
  const [blocks, setBlocks] = useState([]);
  const [action, setAction] = useState('add');
  const [, setEditSelected] = useState({});
  const [, setIndexSelected] = useState(-1);

  const formDialog = () => {
    if (action === 'edit') {
      setAction('edit');
      const data = { ...blocks };
      if (data.scParameters) {
        delete data.scParameters;
      }
      setEditSelected(data);
    } else {
      setAction('add');
      setEditSelected({});
    }

    setOpenDialog(true);
  };

  const doAction = (newData, action) => {
    const actions = {
      add: addParam,
    };
    actions[action](newData);
  };

  const addParam = (newData) => {
    setBlocks((prev) => [...prev, newData]);
    bodyChange([...blocks, newData]);
    setOpenDialog(false);
  };

  const update = (newData, i) => {
    blocks[i] = newData;
    setBlocks(blocks);
    bodyChange(blocks);
  };

  const remove = (i) => {
    setIndexSelected(i);
    const data = [...blocks];
    data.splice(i, 1);
    setBlocks(data);
    bodyChange(data);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (dataBody.length) {
      setBlocks(dataBody);
    }
  }, [dataBody]);

  return (
    <Grid container direction="row" alignItems="center" spacing={2} item xs={9}>
      {blocks.length === 0 && (
        <Grid item xs={12}>
          <Box p={10} className={`${classes.rectangle} ${classes.blocks}`}>
            <Button
              className={classes.btn}
              onClick={() => formDialog('add')}
              startIcon={<Icons icon='plusCircle' color='#2B3990'  size='18' />}
            >
              تعریف پارامتر جدید
            </Button>
          </Box>
        </Grid>
      )}

      <Grid item xs={12}>
        <Box className={classes.blocks}>
          {blocks.length > 0 &&
            blocks.map((block, i) => (
              <Params
                block={block}
                key={i}
                parentIndex={i}
                update={(newData) => update(newData, i)}
                remove={() => remove(i)}
              />
            ))}
        </Box>
      </Grid>

      {blocks.length > 0 && (
        <Grid item xs={12}>
          <Box style={{ position: 'relative' }}>
            <div className={classes.vl} />
            <div className={classes.hl} />
            <Box ml={5}>
              <Button
                className={classes.btn}
                onClick={() => formDialog('add')}
                startIcon={<Icons icon='plusCircle' color='#006cfc' size='18' />}
              >
                تعریف پارامتر جدید
              </Button>
            </Box>
          </Box>
        </Grid>
      )}

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        title={titleDialog}
        onClose={handleCloseDialog}
      >
        <BodyForm onClick={doAction} action={action} />
      </SimpleDialog>
    </Grid>
  );
};

export default BodyParameters;
